module.exports = __webpack_public_path__ + "static/office-1-919816ae2a5cc8b3f9dbbf98617b247f.webp";